import { SVGProps } from "react";

export default function IconCheck(props: SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.37127 8.44993C1.54208 7.27326 3.40197 6.95063 3.80052 8.33606C3.87643 8.86746 3.93337 10.8222 4.55966 10.8602L13.992 1.71257C15.1496 0.59284 15.2256 2.24397 14.6182 2.94617L4.6925 14.2004C2.92751 16.1931 0.972723 11.3347 1.39025 8.46891L1.37127 8.44993Z" fill="currentColor"/>
            </svg>
    );
}
